// @flow

export const fileIdToUrl = (
  fileId: string,
  downloadAttachment: boolean = true
) => `/data/s3-uploads/${fileId}?download=${downloadAttachment.toString()}`;
